import Reflux from "reflux";
const IndexerActions = {
  get: Reflux.createAction()
};

export { IndexerActions };
